import { useEffect, useLayoutEffect, useState } from 'react';

import { GoogleOneTapMoments } from 'constants/google';
import { GOOGLE_ID_TOKEN } from 'constants/oAuthKeys';
import { GOOGLE_API_CLIENT_ID } from 'constants/runtimeConfig';
import { openOAuthPopup } from 'utilities/auth';
import { incrementMetric } from 'utilities/metrics';
import { getFilteredPathnames } from 'utilities/url';

export function GoogleIdentity({ onPrompt, prompt, ...initializeOptions }) {
  const [prompted, setPrompted] = useState(false);
  const [initialized, setInitialized] = useState(false);

  const currentPath = getFilteredPathnames(window.location.pathname)[0];

  useEffect(() => {
    window?.google?.accounts?.id?.initialize?.({
      ...initializeOptions,
      client_id: GOOGLE_API_CLIENT_ID,
      callback(data) {
        if (data?.credential) {
          openOAuthPopup(GOOGLE_ID_TOKEN, {
            id_token: data.credential,
          });
        }

        incrementMetric('google_one_tap.accepted', {
          source: currentPath,
        });

        initializeOptions?.callback?.(data);
      },
    });
    setInitialized(true);
  }, [prompt, prompted, onPrompt, initialized]);

  useLayoutEffect(() => {
    if (!prompted && prompt && initialized) {
      window?.google?.accounts?.id?.prompt(notification => {
        if (notification.isDisplayed()) {
          incrementMetric('google_one_tap.displayed', {
            source: currentPath,
          });
        } else {
          switch (notification.getMomentType()) {
            case GoogleOneTapMoments.DISPLAY:
              incrementMetric('google_one_tap.not_displayed', {
                reason: notification.getNotDisplayedReason(),
                source: currentPath,
              });

              break;
            case GoogleOneTapMoments.SKIPPED:
              incrementMetric('google_one_tap.skipped', {
                reason: notification.getSkippedReason(),
                source: currentPath,
              });

              break;
            case GoogleOneTapMoments.DISMISSED:
              incrementMetric('google_one_tap.dismissed', {
                reason: notification.getDismissedReason(),
                source: currentPath,
              });

              break;
            default:
              break;
          }
        }
      });

      setPrompted(true);
    }
  }, [prompt, prompted, onPrompt, initialized, currentPath]);

  return null;
}
